import types from './RequestPriorityType';

export default class RequestPriorityDescription {
    static [types.CRITICAL] = 'Критический / массовый';
    static [types.HIGH] = 'Высокий';
    static [types.NORMAL] = 'Обычный';
    static [types.LOW] = 'Низкий';
}
